import { render, staticRenderFns } from "./SwapContainer.vue?vue&type=template&id=b2f45562&scoped=true&"
import script from "./SwapContainer.vue?vue&type=script&lang=js&"
export * from "./SwapContainer.vue?vue&type=script&lang=js&"
import style0 from "./SwapContainer.vue?vue&type=style&index=0&id=b2f45562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f45562",
  null
  
)

export default component.exports